import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { useForm } from 'react-hook-form';
import { CoreContext } from '../../context/index.js';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import { selectEmail } from '../../storeSelectors/email.js';
import { setUserInformation, setUserCart } from '../../utils/salesforce.js';
import { getCartSessionId } from '../../utils/cart.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import useAutoFocus from '../../hooks/useAutoFocus.js';
import useCaptcha from '../../hooks/useCaptcha.js';
import '../../index-sNwiaBfD.js';
import 'next/router';
import 'notistack';
import useShowNotify from '../../hooks/useShowNotify.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import '../../helpers-kA_hdoOI.js';
import 'lodash';
import useUserInteractionEvent from '../../hooks/useUserInteractionEvent.js';
import { getValidationSchema, getInitialValues } from './form/index.js';
import Button from '../Button/index.js';
import ButtonGroup from '../ButtonGroup/index.js';
import { I as Input } from '../../Input-quQLghm0.js';
import { I as InputPassword } from '../../InputPassword-SnmSpVSN.js';
import Loader from '../Loader/index.js';
import Link from '../Link/index.js';
import { H as HCaptchaComponent } from '../../HCaptcha-z_AMrNS9.js';
import { G as GetHCaptchaToken } from '../../GetHCaptchaToken-sJpm0bg0.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../utils/currency.js';
import 'react-i18next';
import '../../utils/cookies.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/isBot.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../requestsCollection-gritD79O.js';
import '../../services/auth/index.js';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/product.js';
import '../../utils/logger.js';
import '../../paths-ZKN3m62_.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-Vtx0Wqgk.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/error.js';
import '../../utils/logToRelic.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import '../../storeSelectors/captcha.js';
import 'i18next';
import '../../index-_7uIHHAF.js';
import '../../utils/auth.js';
import '../../utils/dataRouteFormat.js';
import 'yup';
import '@hookform/resolvers/yup';
import '../../utils/validation.js';
import '../../validation-AjMAVn7m.js';
import '../../index-2586sEvh.js';
import '../CircularProgress/index.js';
import 'next/link';
import '@hcaptcha/react-hcaptcha';

const LoginForm = ({ showCreateAccountButton, showHCaptcha, focusOnLoad = true, legend, validateHCaptchaTokenOnServer, onToggleCreateAccount, onToggleForgotPassword, onSubmitted, onShowNotify, }) => {
    var _a;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const [serverError, setServerError] = useState(null);
    const [captchaLoading, setCaptchaLoading] = useState(false);
    const { manualUserClickHandler } = useUserInteractionEvent();
    const context = useContext(CoreContext);
    const { useSelector, useDispatch, useGetLoadingStatus, thunks: { user: { login }, cart: { getCart }, }, actions: { prefill: { setEmail }, }, apolloConfig, data: { siteConfig: { catalogId, accorTagging: { accorTaggingEnabled = false } = {} }, }, } = context;
    const initialEmail = useSelector(selectEmail);
    const showNotifyHook = useShowNotify();
    const showNotify = onShowNotify || showNotifyHook;
    const dispatch = useDispatch();
    const isLoading = useGetLoadingStatus(login);
    const { isFulfilled: isCaptchaFulfilled, captcha } = useCaptcha();
    const showCaptcha = isCaptchaFulfilled && captcha.login;
    const captchaSiteKey = captcha.public_key;
    const { register, control, handleSubmit, setValue, setError, clearErrors, getValues, formState: { errors, isValid }, } = useForm({
        resolver: getValidationSchema(showCaptcha && showHCaptcha),
        defaultValues: getInitialValues(initialEmail),
        mode: 'onSubmit',
    });
    const onSubmit = async ({ ...restValues }) => {
        setServerError('');
        const resultAction = await dispatch(login(restValues));
        if (login.fulfilled.match(resultAction)) {
            showNotify(tValidation('loginSuccess'));
            setUserInformation(catalogId, restValues.email);
            const cart = await dispatch(getCart({ cart_id: getCartSessionId(), accorTaggingEnabled }));
            if ('items' in cart.payload)
                setUserCart(cart.payload);
            manualUserClickHandler('login', {
                category: 'authentification',
                action: 'sign in - click on cta',
                label: 'connect - connect',
            });
            onSubmitted();
        }
        else if (resultAction.error.message === 'Rejected') {
            setServerError('$common.$validation.loginRejected');
        }
        else {
            setServerError(resultAction.payload.errorMessage);
        }
    };
    const handleCaptchaVerify = async (token) => {
        setCaptchaLoading(true);
        const success = await validateHCaptchaTokenOnServer(apolloConfig, token, GetHCaptchaToken);
        if (success) {
            setValue('captcha', token);
            clearErrors('captcha');
        }
        else {
            setValue('captcha', null);
            // TODO: add translation
            setError('captcha', { message: 'Captcha token is invalid' });
        }
        setCaptchaLoading(false);
    };
    const handleCaptchaExpire = () => {
        setValue('captcha', null);
        setError('captcha', { message: tValidation('captchaExpired') });
    };
    useEffect(() => {
        if (!initialEmail)
            return;
        dispatch(setEmail(null));
    }, []);
    const ref = useAutoFocus({ tag: 'input', focusOnLoad });
    return (React.createElement("form", { className: "auth-form", onSubmit: handleSubmit(onSubmit) },
        React.createElement("fieldset", null,
            React.createElement("legend", { className: "sr-only" }, legend),
            React.createElement("div", { ref: ref, className: "row" },
                React.createElement(Input, { name: "email", id: `email${focusOnLoad ? '-side' : ''}`, autocomplete: "email", label: `${tLabel('emailAddr')} *`, placeholder: `${tLabel('emailAddr')} *`, register: register, errors: errors, inputMode: "email" })),
            React.createElement("div", { className: "row" },
                React.createElement(InputPassword, { name: "password", id: `password${focusOnLoad ? '-side' : ''}`, control: control, autocomplete: "current-password", label: `${tLabel('password')} *`, placeholder: `${tLabel('password')} *`, errors: errors })),
            showHCaptcha && showCaptcha && (React.createElement("div", { className: "row" },
                React.createElement(HCaptchaComponent, { siteKey: captchaSiteKey, error: (_a = errors.captcha) === null || _a === void 0 ? void 0 : _a.message, onVerify: handleCaptchaVerify, onExpire: handleCaptchaExpire }))),
            React.createElement("div", { className: "row row-note" },
                React.createElement("span", { className: "note", title: tLabel('requiredSignMeans') },
                    "* ",
                    tLabel('requiredFields'))),
            React.createElement("div", { className: "forget-button-row" },
                React.createElement(Link, { className: "forget-button", onClick: onToggleForgotPassword }, tLabel('forgetPWDLink'))),
            React.createElement(ButtonGroup, { vertical: "max-660", align: showCreateAccountButton ? 'space-between' : 'right' },
                showCreateAccountButton && (React.createElement(Button, { type: "button", variant: "plain", className: "btn", disabled: isLoading, onClick: () => onToggleCreateAccount(getValues()) }, tLabel('createAccount'))),
                isLoading ? (React.createElement(Loader, null)) : (React.createElement(Button, { type: "submit", className: "btn", disabled: isLoading ||
                        (!isValid && Object.keys(errors).length > 0) ||
                        (showHCaptcha ? captchaLoading : false) }, tButton('logIn')))),
            serverError && (React.createElement("div", { role: "alert", id: "serverError", className: "error-ui" }, t(serverError))))));
};
var LoginForm$1 = withProviders(LoginForm, { translation: true, snackbar: true });

export { LoginForm$1 as default };
//# sourceMappingURL=index.js.map
